import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=58ce80c7&scoped=true"
import script from "./InputMoney.vue?vue&type=script&lang=js"
export * from "./InputMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce80c7",
  null
  
)

export default component.exports